import { z } from 'zod'

export const Environment = z
  .enum(['development', 'staging', 'production', 'test'])
  .default('development')
export type Environment = z.infer<typeof Environment>
